import React, { useEffect, useState } from 'react';
import api from '../../services/api';

export default function AdminAlerts() {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [unreadOnly, setUnreadOnly] = useState(false);

  const loadAlerts = () => {
    const params = unreadOnly ? '?unread_only=1' : '';
    api.get(`/admin/alerts${params}`)
      .then((res) => setAlerts(res.data?.data || []))
      .catch(() => setAlerts([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    loadAlerts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unreadOnly]);

  const handleMarkAsRead = (id) => {
    api.patch(`/admin/alerts/${id}/read`)
      .then(() => loadAlerts())
      .catch(() => {});
  };

  if (loading) return <p className="text-gray-500">Chargement...</p>;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-800">Alertes</h1>
        <label className="flex items-center gap-2 text-sm">
          <input
            type="checkbox"
            checked={unreadOnly}
            onChange={(e) => setUnreadOnly(e.target.checked)}
          />
          Non lues uniquement
        </label>
      </div>

      {alerts.length === 0 ? (
        <div className="bg-white rounded-lg shadow p-8 text-center text-gray-500">
          <p>Aucune alerte.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {alerts.map((a) => {
          const typeLabels = {
            score_drop: 'Baisse de score',
            threshold: 'Seuil critique',
            service_below: 'Service sous moyenne',
          };
          const typeIcon = { score_drop: '📉', threshold: '⚠️', service_below: '🏢' };
          return (
            <div
              key={a.id}
              className={`bg-white rounded-lg shadow p-4 border-l-4 ${
                a.read_at ? 'border-gray-300' : 'border-amber-500'
              }`}
            >
              <div className="flex justify-between items-start">
                <div>
                  {a.type && (
                    <span className="text-xs font-medium text-amber-700 bg-amber-100 px-2 py-0.5 rounded inline-block mb-1">
                      {typeIcon[a.type] || '•'} {typeLabels[a.type] || a.type}
                    </span>
                  )}
                  <p className="font-medium text-gray-800">{a.message}</p>
                  <p className="text-sm text-gray-500 mt-1">
                    {a.created_at && new Date(a.created_at).toLocaleString('fr-FR')}
                    {a.survey && ` • ${a.survey.title}`}
                  </p>
                </div>
                {!a.read_at && (
                  <button
                    onClick={() => handleMarkAsRead(a.id)}
                    className="text-sm text-primary-600 hover:underline"
                  >
                    Marquer comme lu
                  </button>
                )}
              </div>
            </div>
          );
        })}
        </div>
      )}
    </div>
  );
}
